import { Link } from 'react-router-dom';
import { LayoutDashboard, Users, FileText, Gavel, Settings, CreditCard } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

interface NavItem {
  to: string;
  label: string;
  icon: typeof Users;
  enabled: boolean;
}

const NAV: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, enabled: true },
  { to: '/clients', label: 'Clients', icon: Users, enabled: true },
  { to: '/clients', label: 'Reports', icon: FileText, enabled: true },
  { to: '/clients', label: 'Disputes', icon: Gavel, enabled: true },
  { to: '/billing', label: 'Billing', icon: CreditCard, enabled: true },
  { to: '/settings', label: 'Settings', icon: Settings, enabled: true },
];

export function Dashboard() {
  const { user } = useAuth();

  return (
    <section className="mx-auto max-w-6xl px-6 py-10 space-y-6">
        <h1 className="text-2xl font-semibold tracking-tight">
          Welcome back, {user?.firstName ?? user?.email}
        </h1>
        <p className="text-muted-foreground text-sm max-w-2xl">
          You are signed in as <strong>{user?.role}</strong> on tenant{' '}
          <code className="text-xs bg-muted px-1.5 py-0.5 rounded">
            {user?.tenantId}
          </code>.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <div
                key={item.to}
                className={`rounded-lg border p-5 ${item.enabled ? 'bg-card' : 'bg-muted/40'}`}
              >
                <div className="flex items-center gap-3 mb-2">
                  <Icon className="size-5 text-primary" />
                  <h3 className="font-medium">{item.label}</h3>
                </div>
                <p className="text-sm text-muted-foreground mb-3">
                  {item.enabled
                    ? 'Available.'
                    : 'Implemented in a later milestone (currently disabled).'}
                </p>
                {item.enabled ? (
                  <Link
                    to={item.to}
                    className="text-sm text-primary hover:underline"
                  >
                    Open →
                  </Link>
                ) : (
                  <span className="text-xs text-muted-foreground">—</span>
                )}
              </div>
            );
          })}
        </div>
    </section>
  );
}